module.exports = __webpack_public_path__ + "static/media/move.c41ba263.svg";